// Meta Pixel utility — handles initialization and event tracking.
// Pixel ID: 1941520056482038 (Glow Up Femenino — bypaolarojas.com)

const PIXEL_ID = '1941520056482038'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (initialized || window.fbq) return

  // Initialize the Meta Pixel queue (same shape as Meta's official snippet).
  const w = window as any
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  w.fbq = n
  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject the Facebook events script. Using document.head.appendChild is
  // more reliable than the official snippet's `insertBefore(firstScript)`
  // trick in single-page React apps where no inline <script> tag may be
  // present (which caused: Cannot read properties of undefined (parentNode)).
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // <noscript> fallback pixel for users with JS disabled.
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  initialized = true
}

export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  if (params) {
    window.fbq('track', eventName, params)
  } else {
    window.fbq('track', eventName)
  }
}

export const PRODUCT_EVENT_PARAMS = {
  content_name: 'Glow Up Femenino en 30 Días',
  content_type: 'product',
  currency: 'USD',
  value: 19.99,
}

export function trackViewContent(): void {
  trackEvent('ViewContent', PRODUCT_EVENT_PARAMS)
}

export function trackInitiateCheckout(): void {
  trackEvent('InitiateCheckout', PRODUCT_EVENT_PARAMS)
}
